"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgreementModalContainer = void 0;
var react_1 = __importDefault(require("react"));
var DIProvider_1 = __importDefault(require("@CommonFrontend/DIProvider/DIProvider"));
var inversify_1 = require("inversify");
var AngularSyncStore_1 = require("@CommonFrontend/Utils/AngularSyncStore");
var AgreementModal_1 = require("@CommonFrontend/AgreementView/AgreementModal");
var BlockTitle_1 = require("./Components/BlockTitle");
var AgreementBlock_1 = require("./Components/AgreementBlock");
var AcceptForm_1 = require("./Components/AcceptForm");
var partiallyApplyComponent_1 = __importDefault(require("@CommonFrontend/QuoteV2/Components/partiallyApplyComponent"));
var AgreementContextProvider_1 = require("@CommonFrontend/AgreementView/AgreementContextProvider");
var AgreementNavigationDrawer_1 = __importDefault(require("@CommonFrontend/AgreementView/AgreementNavigationDrawer"));
var DownloadPdfButton_1 = __importDefault(require("./Components/DownloadPdfButton"));
var GuidedFlowStore_1 = require("@CommonFrontend/GuidedFlow/GuidedFlowStore");
var GuidedFlow_1 = require("@CommonFrontend/GuidedFlow/GuidedFlow");
var AgreementModalContainer = function (_a) {
    var onDismiss = _a.onDismiss, $scope = _a.$scope, $timeout = _a.$timeout, accepters = _a.accepters, acceptBlockSettings = _a.acceptBlockSettings, autofillEnabled = _a.autofillEnabled, acceptBlockStyles = _a.acceptBlockStyles, disableNavigationButton = _a.disableNavigationButton, acceptedInCurrentSession = _a.acceptedInCurrentSession, requiresQuoteChoice = _a.requiresQuoteChoice, isPrintMode = _a.isPrintMode, pdfUrl = _a.pdfUrl, projectStatus = _a.projectStatus, _b = _a.usingSignatureInitialsWidgets, usingSignatureInitialsWidgets = _b === void 0 ? false : _b;
    var guidedFlowStore = GuidedFlowStore_1.GuidedFlowStore.getInstance();
    return (react_1.default.createElement(DIProvider_1.default, { container: function () {
            var container = new inversify_1.Container({ skipBaseClassChecks: true });
            container.bind("angularData").toConstantValue($scope);
            container.bind(AgreementModal_1.AgreementStore).toSelf();
            container.bind(AngularSyncStore_1.AngularSyncServices.$).toConstantValue(!!$scope ? { $scope: $scope, $timeout: $timeout } : { disableSync: true });
            container.bind("pdfUrl").toConstantValue(pdfUrl);
            container.bind("guidedFlowStore").toConstantValue(guidedFlowStore);
            container.bind(AgreementModal_1.AgreementModalComponents.$).toConstantValue({
                BlockTitle: BlockTitle_1.BlockTitle,
                AgreementNavigationDrawer: AgreementNavigationDrawer_1.default,
                DownloadPdfButton: (0, partiallyApplyComponent_1.default)(DownloadPdfButton_1.default, { projectStatus: projectStatus }),
                BlockContent: (0, partiallyApplyComponent_1.default)(AgreementBlock_1.AgreementBlockComponent, { block: $scope.agreementBlock }),
                AcceptForm: (0, partiallyApplyComponent_1.default)(AcceptForm_1.AcceptForm, {
                    $timeout: $timeout,
                    onCloseModal: onDismiss,
                    autofillEnabled: autofillEnabled,
                    accepters: accepters,
                    acceptBlockSettings: acceptBlockSettings,
                    acceptedInCurrentSession: acceptedInCurrentSession,
                    requiresQuoteChoice: requiresQuoteChoice,
                    usingSignatureInitialsWidgets: usingSignatureInitialsWidgets,
                    isInAgreement: true,
                }),
                AgreementContextProvider: (0, partiallyApplyComponent_1.default)(AgreementContextProvider_1.AgreementContextProvider, {
                    buttonColor: acceptBlockStyles.buttonColor,
                    disableNavigationButton: disableNavigationButton,
                    isPrintMode: isPrintMode,
                }),
                GuidedFlowBlockWrapper: (0, partiallyApplyComponent_1.default)(GuidedFlow_1.GuidedFlowBlockWrapper, {}),
            });
            return container;
        } },
        react_1.default.createElement(AgreementModal_1.AgreementModal, { onDismiss: onDismiss })));
};
exports.AgreementModalContainer = AgreementModalContainer;
